"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEvent = createEvent;
function createEvent(eventType, data) {
    let event = { type: eventType, data: data };
    return event;
}
